export default {
  create_org: {
    title: 'Gérez Vos Événements Académiques',
    description:
      'Créez des sites web attrayants et simplifiez la gestion des inscriptions, des résumés et de leur évaluation. Gagnez du temps et offrez une expérience mémorable à vos participants.',
    modal_title: 'Créer une organisation',
    maybe_later: 'Peut-être plus tard',
    create: 'Débuter',
    infos: {
      title: 'Information générale',
      name: 'Nom de votre organisation',
      name_hint:
        'Soyez le plus précis possible. Il peut s’agir de votre département, laboratoire ou du nom de votre conférence.',
      address: 'Adresse',
      address_hint: 'Requis pour publier vos événements, mettre à niveau votre plan, etc.',
      city: 'Ville',
      zip: 'Code postal ou ZIP',
    },
    add_admins: {
      title: "Ajout d'administrateurs",
      subtitle:
        'Invitez vos collègues à rejoindre votre organisation. Un courriel sera envoyé à chacun, contenant un lien pour activer leur compte ou se connecter.',
      emails: 'Adresses courriel',
      emails_placeholder: 'colleague@something.edu',
      emails_help: 'Tapez une ou plusieurs adresses courriel.',
    },
    success_message: 'Organisation créée avec succès!',
  },
};
